/**
 * @generated SignedSource<<8e0e769b040f293a140e024b4b2357e6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AddIncludeTreeUnlockedDispatchConditionInput = {
  clientMutationId?: string | null;
  messageDispatchId: string;
  rootNodeIds: ReadonlyArray<string>;
};
export type useDispatchConditions_AddIncludeTreeUnlockedDispatchConditionMutation$variables = {
  input: AddIncludeTreeUnlockedDispatchConditionInput;
};
export type useDispatchConditions_AddIncludeTreeUnlockedDispatchConditionMutation$data = {
  readonly Admin: {
    readonly Message: {
      readonly addIncludeTreeUnlockedDispatchCondition: {
        readonly clientMutationId: string | null;
      } | null;
    };
  };
};
export type useDispatchConditions_AddIncludeTreeUnlockedDispatchConditionMutation = {
  response: useDispatchConditions_AddIncludeTreeUnlockedDispatchConditionMutation$data;
  variables: useDispatchConditions_AddIncludeTreeUnlockedDispatchConditionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AdminMutationType",
    "kind": "LinkedField",
    "name": "Admin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MessageAdminMutationSchema",
        "kind": "LinkedField",
        "name": "Message",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
              }
            ],
            "concreteType": "AddIncludeTreeUnlockedDispatchConditionPayload",
            "kind": "LinkedField",
            "name": "addIncludeTreeUnlockedDispatchCondition",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "clientMutationId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useDispatchConditions_AddIncludeTreeUnlockedDispatchConditionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useDispatchConditions_AddIncludeTreeUnlockedDispatchConditionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3c04a72bd02288224c6fb07001ffceca",
    "id": null,
    "metadata": {},
    "name": "useDispatchConditions_AddIncludeTreeUnlockedDispatchConditionMutation",
    "operationKind": "mutation",
    "text": "mutation useDispatchConditions_AddIncludeTreeUnlockedDispatchConditionMutation(\n  $input: AddIncludeTreeUnlockedDispatchConditionInput!\n) {\n  Admin {\n    Message {\n      addIncludeTreeUnlockedDispatchCondition(input: $input) {\n        clientMutationId\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "15da1841d950285ede1d559667e0ba61";

export default node;
